import React, { FC } from "react";
import { ReactComponent as MicrosoftSvg } from "assets/images/microsoftIcon.svg";
import Icon from "@ant-design/icons";

type IconProps = React.ComponentProps<typeof Icon>;
const MicrosoftIcon: FC<IconProps> = (props) => <Icon component={MicrosoftSvg} {...props} />;

export default MicrosoftIcon;
